<template>
	<main class="vx-row">
		<div class="vx-col w-full">
			<vx-card>
				<div class="vx-row justify-center">
					<div class="vx-col w-full md:w-3/4 lg:w-1/2">
						<h6 class="mb-6"><strong>Pengajuan Penerima Manfaat</strong></h6>

						<form-wizard
							ref="pm"
							color="rgba(var(--vs-warning), 1)"
							:title="null"
							:subtitle="null"
							:hide-buttons="true"
						>
							<tab-content
								title="Verifikasi"
								class="mb-4"
							>
								<pm-verifikasi 
									@setFileKTP="setFileKTP"
									@submit="submitVerifikasi"
								/>
							</tab-content>
							<tab-content
								title="Isi Form"
								class="mb-4"
							>
								<pm-form
									@setFileEvidence="setFileEvidence"
									@submit="submitForm"
								/>
							</tab-content>
							<!-- <tab-content
								title="Metode"
								class="mb-4"
							>
								<pm-metode
									@submit="submitMetode"
								/>
							</tab-content> -->
							<tab-content
								title="Preview"
								class="mb-4"
							>
								<pm-preview
									:data="datas"
									@submit="submit"
									@back="back"
								/>
							</tab-content>
						</form-wizard>
					</div>
				</div>
			</vx-card>
		</div>
	</main>
</template>
<script>
	import { FormWizard, TabContent } from 'vue-form-wizard'
	import 'vue-form-wizard/dist/vue-form-wizard.min.css'
	import {mapState} from 'vuex'

	export default {
		computed: {
			...mapState('auth', ['profile']),
			...mapState('campaign', ['savedPm'])
		},
		data: () => ({
			file_ktp: null,
			file_evidence: null,
			name: null,
			nik: null,
			jk: null,
			keterangan: null,
			tempat_lahir: null,
			tanggal_lahir: null,
			alamat: null,
			pekerjaan: null,
			no_telp: null,
			status: 2,
			tipe: null,
			status_identity: 1,
			status_aproval: 2,
			user_id: 0,
			jumlah_kebutuhan: 0,
			acc_kebutuhan: 0,
			deskripsi_kebutuhan: null,
			fitur_id: 0,
			metode: null,
			bank: null,
			no_rekening: null,
			datas: {
				no: 0
			}
		}),
		methods: {
			back() {
				this.$refs.pm.prevTab()
			},
			submitVerifikasi(payload) {
				// change to next form
				this.name = payload.name;
				this.pekerjaan = payload.pekerjaan;
				this.no_telp = payload.no_telp;
				this.nik = payload.nik;
				this.alamat = payload.alamat;
				this.jk = payload.jk.id;
				this.tanggal_lahir = payload.tanggal_lahir;
				this.tempat_lahir = payload.tempat_lahir;

				this.$refs.pm.nextTab();
			},
			submitForm(payload) {
				this.tipe = payload.tipe;
				this.keterangan = payload.keterangan;
				this.jumlah_kebutuhan = payload.jumlah_kebutuhan;
				this.deskripsi_kebutuhan = payload.deskripsi_kebutuhan;

				this.$store.dispatch('campaign/saveDataPM', {
					file_ktp: this.file_ktp,
					file_evidence: this.file_evidence,
					name: this.name,
					pekerjaan: this.pekerjaan,
					handphone: this.no_telp,
					tempat_lahir: this.tempat_lahir,
					tanggal_lahir: this.tanggal_lahir,
					nik: this.nik,
					jenis_kelamin: this.jk,
					keterangan: this.keterangan,
					alamat: this.alamat,
					status: this.status,
					tipe: this.tipe,
					status_identity: this.status_identity,
					status_aproval: this.status_aproval,
					user_id: this.user_id,
					jumlah_kebutuhan: this.jumlah_kebutuhan,
					acc_kebutuhan: 0,
					acc_kebutuhan: this.acc_kebutuhan,
					deskripsi_kebutuhan: this.deskripsi_kebutuhan,
					fitur_id: this.fitur_id,
					metode: this.metode,
					bank: this.bank,
					no_rekening: this.no_rekening,
				});

				this.$refs.pm.nextTab();
			},
			submitMetode(payload) {
				this.metode = payload.metode;
				this.bank = payload.bank;
				this.no_rekening = payload.no_rekening;
				this.$refs.pm.nextTab();
			},
			setFileKTP(file) {
				this.file_ktp = file;
			},
			setFileEvidence(file) {
				this.file_evidence = file;
			},
			submit() {
				this.$vs.loading({
					container: '#btn-submit',
					scale: 0.5
				});
				// upload the file evidence first
				this.$store.dispatch('uploadFileMitra', {
					file_ktp: this.file_ktp,
					file_evidence: this.file_evidence
				})
				.then(files => {
					const file_ktp = files.find(it => it.type === 'file_ktp'),
						file_evidence = files.find(it => it.type === 'file_evidence');
					
					this.$store.dispatch('campaign/saveDataPM', {
						file_ktp: file_ktp.link,
						file_evidence: file_evidence.link,
						name: this.name,
						pekerjaan: this.pekerjaan,
						handphone: this.no_telp,
						tempat_lahir: this.tempat_lahir,
						tanggal_lahir: this.tanggal_lahir,
						nik: this.nik,
						jenis_kelamin: this.jk,
						keterangan: this.keterangan,
						alamat: this.alamat,
						status: this.status,
						tipe: this.tipe,
						status_identity: this.status_identity,
						status_aproval: this.status_aproval,
						user_id: this.user_id,
						jumlah_kebutuhan: this.jumlah_kebutuhan,
						acc_kebutuhan: 0,
						acc_kebutuhan: this.acc_kebutuhan,
						deskripsi_kebutuhan: this.deskripsi_kebutuhan,
						fitur_id: this.fitur_id,
						metode: this.metode,
						bank: this.bank,
						no_rekening: this.no_rekening,
					})
					.then(() => {
						
						this.$store.dispatch('campaign/requestPM', [ this.savedPm ])
						.then(() => {
							this.$vs.loading.close(`#btn-submit > .con-vs-loading`);
							this.$store.dispatch('campaign/removePm');
							this.$router.push(`/campaign/${this.$route.params.id}/success-pm`);
						})
						.catch(e => {
							console.error(e);
							this.$vs.loading.close(`#btn-submit > .con-vs-loading`);

							return false;
						});
					})
					.catch(e => {
						console.error(e);
						this.$vs.loading.close(`#btn-submit > .con-vs-loading`);

							return false;
					});
				})
				.catch(e => {
					console.error(e);
					this.$vs.loading.close(`#btn-submit > .con-vs-loading`);

					return false;
				});

				setTimeout(() => {
					this.$vs.loading.close('#btn-submit > .con-vs-loading');
				}, 1000);
			}
		},
		components: {
			FormWizard,
			TabContent,
			PmVerifikasi: () => import('./components/PMVerifikasi.vue'),
			PmForm: () => import('./components/PMForm.vue'),
			PmMetode: () => import('./components/PMMetode.vue'),
			PmPreview: () => import('./components/PMPreview.vue')
		},
		created() {
			this.fitur_id = this.$route.params.id;
			this.user_id = this.profile.id;
			this.$store.dispatch('campaign/removePm');
		}
	}
</script>